/**
 * debounce -  A utility function to limit the rate at which a function is executed
 *
 * This function delays the execution of the given function until after a specified amount of time
 * has passed since the last time it was invoked. It is commonly used to improve performance in events like resizing, scrolling or typing
 *
 * @param {*} func The function to be executed after the delay
 * @param {*} delay The amount of time in miliseconds to wait before executing the function
 * @returns {function} A debounced version of the original function
 */
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export default debounce;
